<script>
import moment from "moment-timezone";
import { postPaged } from "@/services/paginated";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
/**
 * Register component
 */
export default {
  page: {
    title: "Danh sách khách hàng",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader
  },


   data() {
    return {
      json_fields: {
        "Mã hóa đơn": "invoice",
        "Ngày tạo": "crt",
        "Dịch vụ": "service_name",
        "Người gửi": "sender_fn",
        "SĐT gửi": "sender_phone",
        "Người nhận": "recipient_fn",
        "SĐT nhận": "recipient_phone",
        "Tổng tiền": "total_changer",
        "Trạng thái": "status",
      },
      json_meta: [[{ key: "charset", value: "utf-8" }]],

      columns: [
        { label: "Ngày tạo", field: "crt", width: "160px" },
        { label: "Mã hóa đơn", field: "invoice", width: "140px" },
        { label: "Người gửi", field: "sender_fn" },
        { label: "Người nhận", field: "recipient_fn" },
        { label: "Dịch vụ", field: "service_name" },
        { label: "Trạng thái", field: "status", width: "140px" },
        { label: "Tổng tiền", field: "total_changer", width: "140px" },
        { label: "Hành động", field: "_id", width: "180px" },
      ],

      rows: [],
      totalRows: 0,
      page: 1,
      perPage: 10,
      searchTerm: "",
      isLoading: false,
    };
  },

  methods: {
    // ✅ gọi API rút gọn nhờ postPaged
    async fetchBillings() {
      this.isLoading = true;
      const data = await postPaged("/api/bill/list", {
        page: this.page,
        limit: this.perPage,
        search: this.searchTerm,
      });
      this.rows = data.items || [];
      this.totalRows = data.total || 0;
      this.isLoading = false;
    },

    onPageChange(params) {
      this.page = params.currentPage;
      this.fetchBillings();
    },
    onPerPageChange(params) {
      this.perPage = params.currentPerPage;
      this.page = 1;
      this.fetchBillings();
    },
    onSearch(params) {
      this.searchTerm = params.searchTerm;
      this.page = 1;
      this.fetchBillings();
    },

    formatDate(_data) {
      return moment
        .tz(_data, "UTC")
        .tz("America/Los_Angeles")
        .format("DD-MM-YYYY HH:mm");
    },
    formatMoney(value) {
      if (!value && value !== 0) return "";
      return Number(value).toLocaleString("en-US") + " $";
    },
    renderName() {
      return moment().format("HH:mm DD-MM-YYYY") + "-billings.xls";
    },

    viewDetail(_id) {
       this.$router.push({name: "bill-detaild",query: {id: _id,},
      });
    },
    editBilling(_id) {
      this.$router.push({ name: "bill-add", query: { id: _id } });
    },
  },

  async mounted() {
    await this.fetchBillings();
  },


};
</script>

<template>
  <Layout>
    <PageHeader />
    
    <div class="card">
    <div class="card-body">
      <div class="text-sm-end mb-3">
        <export-excel
          class="btn btn-info btn-sm"
          :data="rows"
          :fields="json_fields"
          worksheet="Billing list"
          :name="renderName()"
        >
          <i class="bx bx-download"></i> Tải xuống Excel
        </export-excel>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows"
        :total-rows="totalRows"
        :pagination-options="{
          enabled: true,
          rowsPerPageLabel: 'các mục trong trang',
          nextLabel: 'tiếp',
          prevLabel: 'trước',
          mode: 'records',
          perPage: perPage,
          perPageDropdown: [10, 20, 50, 100],
          allLabel: 'Tất cả',
        }"
        :line-numbers="true"
        :search-options="{ enabled: true, placeholder: 'Tìm kiếm hóa đơn...' }"
        mode="remote"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
        @on-search="onSearch"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Hành động -->
          <span v-if="props.column.field === '_id'">
            <button
              class="btn btn-primary btn-sm mx-1"
              @click="viewDetail(props.row._id)"
            >
              Xem
            </button>
            <button
              class="btn btn-info btn-sm"
              @click="editBilling(props.row._id)"
            >
              Sửa
            </button>
          </span>

          <!-- Ngày -->
          <span v-else-if="props.column.field === 'crt'">
            {{ formatDate(props.row.crt) }}
          </span>

          <!-- Tiền -->
          <span v-else-if="props.column.field === 'total_changer'">
            {{ formatMoney(props.row.total_changer) }}
          </span>

          <!-- Trạng thái -->
          <span v-else-if="props.column.field === 'status'">
            <button class="btn btn-sm btn-success">
                Đã xử lý
              </button>
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
    <!-- end row -->
  </Layout>
</template>